import PropTypes from 'prop-types';
import React from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import DateHelper from 'utils/dateHelper';
import { ReactComponent as ArrowLeftIcon } from 'assets/images/svg/arrow-left.svg';

const CustomHeader = (
  {
    date,
    decreaseMonth,
    increaseMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled,
  },
) => (
  <span className="flex items-center justify-around">
    <button
      id="minus-button"
      type="button"
      className={`${
        prevMonthButtonDisabled
          ? 'calendar-arrow-deactive bg-white cursor-default'
          : 'text-primary bg-white border-primary'} flex justify-center items-center border rounded-3 h-8 w-8 ml-8 focus:outline-none text-8`}
      onClick={decreaseMonth}
      disabled={prevMonthButtonDisabled}
    >
      <ArrowLeftIcon className="fill-current h-2.5 text-3" />
    </button>
    <span className="px-5 text-center calendar-month-name min-w-36 text-dark-grey text-5">{DateHelper.formatDate(date, DateHelper.DATE_LARGE_MONTH)}</span>
    <button
      id="plus-button"
      type="button"
      className={`${
        nextMonthButtonDisabled
          ? 'text-light-grey-blue bg-white cursor-default'
          : 'text-primary bg-white border-primary'} flex justify-center items-center border rounded-3 h-8 w-8 mr-8 focus:outline-none text-8`}
      onClick={increaseMonth}
      disabled={nextMonthButtonDisabled}
    >
      <ArrowLeftIcon className="rotate-180 fill-current h-2.5 text-3" />
    </button>
  </span>
);

CustomHeader.propTypes = {
  date: PropTypes.instanceOf(Date).isRequired,
  decreaseMonth: PropTypes.func.isRequired,
  increaseMonth: PropTypes.func.isRequired,
  prevMonthButtonDisabled: PropTypes.bool.isRequired,
  nextMonthButtonDisabled: PropTypes.bool.isRequired,
};

export default CustomHeader;
